import React from "react";
import { withLocalizeStrings } from "../languages/Localize";
import { Flex, Box } from "reflexbox/styled-components";
import styled from "styled-components";

const StyledContainer = styled(Flex)`
    background: ${({ theme }) => theme.colors.transparent};
    height: 50%;
    margin-top: 20%;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;
const StyledHeaderLabel = styled(Flex)`
    color: ${({ theme }) => theme.colors.white};
    text-align: center;
    justify-content: center;
    align-items: center;
    padding: ${({ theme }) => theme.space[3]}px;
`;
const StyledDescription = styled(Box)`
    color: ${({ theme }) => theme.colors.white};
    text-align: center;
`;

const RegisterDone = ({ strings }) => {
    return (
        <StyledContainer sx={{ mx: [3, 4] }}>
            <StyledHeaderLabel fontWeight="bold" fontSize={[3, 4]} padding={3}>
                {strings.register.common.HEADER}
            </StyledHeaderLabel>
            <Box>
                <StyledDescription sx={{ mx: [3, 4], px: [1, 2], fontSize: [1, 2], fontWeight: "light" }}>
                    {strings.register.common.PURCHASER_DESCRIPTION}
                </StyledDescription>
                <StyledDescription sx={{ mx: [3, 4], marginTop: [1, 2], px: [1, 2], fontSize: [2, 3], fontWeight: "semiLight" }}>
                    {strings.register.common.SEND_CONFIRMATION}
                </StyledDescription>
                <StyledDescription sx={{ mx: [3, 4], px: [1, 2], fontSize: [2, 3], fontWeight: "semiLight" }}>
                    {strings.register.common.SEND_CONFIRMATION_THANKS}
                </StyledDescription>
            </Box>
        </StyledContainer>
    );
};

export default withLocalizeStrings(RegisterDone);
